controllers.controller('InviteFriendsController', [
    '$scope', '$state', 'LocaleService', 'constants', '$ionicLoading', 'UserService', 'API', 'Storage', 'ionicToast',
    function ($scope, $state, LocaleService, Const, $ionicLoading, UserService, API, Storage, ionicToast) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });
        $scope.user = UserService.get();

        $ionicLoading.hide();

        $scope.inputModel = {};
        $scope.signedUpFriends = Storage.get('inviteFriends').filter(function (friend) { return !friend.bonusUsd });
        $scope.qualifiedFriends = Storage.get('inviteFriends').filter(function (friend) { return !!friend.bonusUsd });
        $scope.totalEarnings = $scope.qualifiedFriends.reduce(function (accum, friend) {
            return (accum + friend.bonusUsd)
        }, 0);


        $scope.friendInviteActive = Storage.get('friendInviteActive');
        if ($scope.friendInviteActive) {
            API.getFriendInviteId()
                .then(checkResponse)
                .then(function (response) {
                    var urlObject = new URL(Storage.get('friendRegistrationUrl'));
                    urlObject.searchParams.append('invite_id', response['referralLink'])
                    $scope.inputModel.link = urlObject.href;
                })
        }

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'InviteFriendsController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        $scope.copyLink = function() {
            var input = (document.getElementsByClassName('link-input-pandats'));
            HTMLCollection.prototype.isPrototypeOf(input) && input.length && (input = input[0]);

            if (input){
                input.select();
                input.setSelectionRange(0, $scope.inputModel.link.length);
                document.execCommand('copy');
                input.blur();
                window.getSelection().removeAllRanges();

                ionicToast.show($scope.translation.copiedToCB, 'top', false, 5000, '');
            }
        }

    }]);
